import { act, fireEvent, render, screen } from '@testing-library/react'
import {
  StepValidationProvider,
  useStepValidation,
} from 'features/libra/StepValidationContext'
import { type FC } from 'react'
import { beforeAll, describe, expect, it, vi } from 'vitest'

import { AiPrefillButton } from './AiPrefillButton'

let setUnsavedEdits: (hasUnsavedEdits: boolean) => void = () => {}

const UnsavedEditsSource: FC = () => {
  const { setHasUnsavedEdits } = useStepValidation()
  setUnsavedEdits = (hasUnsavedEdits) =>
    setHasUnsavedEdits('form', hasUnsavedEdits)
  return null
}

const renderButton = (onClick = vi.fn()) =>
  render(
    <StepValidationProvider>
      <UnsavedEditsSource />
      <AiPrefillButton tooltip='Own tooltip' onClick={onClick}>
        Pre-fill
      </AiPrefillButton>
    </StepValidationProvider>
  )

describe('AiPrefillButton', () => {
  beforeAll(() => {
    vi.stubGlobal(
      'ResizeObserver',
      class {
        observe() {}
        unobserve() {}
        disconnect() {}
      }
    )
  })

  it('is enabled with its own tooltip while the step is clean', async () => {
    const onClick = vi.fn()
    renderButton(onClick)

    const button = screen.getByRole('button', { name: 'Pre-fill' })
    expect(button).not.toHaveProperty('disabled', true)
    fireEvent.click(button)
    expect(onClick).toHaveBeenCalledTimes(1)

    fireEvent.mouseOver(button)
    expect(await screen.findByText('Own tooltip')).toBeTruthy()
  })

  it('is disabled with the save prompt while the step has unsaved changes', async () => {
    const onClick = vi.fn()
    renderButton(onClick)
    act(() => setUnsavedEdits(true))

    const button = screen.getByRole('button', { name: 'Pre-fill' })
    expect(button).toHaveProperty('disabled', true)
    fireEvent.click(button)
    expect(onClick).not.toHaveBeenCalled()

    fireEvent.mouseOver(button.parentElement as HTMLElement)
    expect(
      await screen.findByText('Save this step before pre-filling with AI')
    ).toBeTruthy()
  })
})
